import { Route } from '@angular/router';
import { ApplicationPage } from 'app/modules/well-schematic-diagram/pages/application/application.page';
import { ConfigurationPage } from 'app/modules/well-schematic-diagram/pages/configuration/configuration.page';
import { EditPage } from 'app/modules/well-schematic-diagram/pages/edit/edit.page';
import { IndexPage } from 'app/modules/well-schematic-diagram/pages/index/index.page';
import { HistoryPage } from './pages/history/history.page';
import { DetailsPage } from './pages/details/details.page';
import { WbsDashboard } from './pages/dashboard/dashboard.page';
import { DashboardViewPage } from './pages/dashboard-view/dashboard-view.page';
import { WellBarrierStatusPage } from './pages/well-barrier-status/well-barrier-status.page';

export const wbsDashboardRoutes: Route[] = [
    {
        path: 'well-schematic-diagram-dashboard',
        component: WbsDashboard,
    },
    {
        path: 'well-schematic-diagram-dashboard/:wellStringId/details/:type',
        component: DashboardViewPage,
    },
];

export const wbsDataManagementRoutes: Route[] = [
    {
        path: 'well-barrier-status',
        component: WellBarrierStatusPage,
    },
    {
        path: 'well-barrier-status/:wellStringId/details/:type',
        component: DetailsPage,
    },
];

export const wsdConfigurationRoutes: Route[] = [
    {
        path: 'well-schematic-diagram',
        component: IndexPage,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'configs',
            },
            {
                path: 'configs',
                component: ConfigurationPage,
            },
            {
                path: 'application',
                component: ApplicationPage,
            },
        ],
    },
    {
        path: 'well-schematic-diagram/:wellStringId/edit/:type',
        component: EditPage,
    },
    {
        path: 'well-schematic-diagram/:wellStringId/history/:type',
        component: HistoryPage,
    },

];
